import { ActionType } from 'typesafe-actions';

import Theme from '@interfaces/themes';

import * as types from './types';
import * as actions from './actions';

export type ThemesAction = ActionType<typeof actions>;

export interface ThemesState {
    readonly list: Theme[];
    readonly one: Partial<Theme>;
    readonly isLoading: boolean;
    readonly error?: string | boolean;
}

const initialState: ThemesState = {
    list: [],
    one: {},
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line */
function reducer(state: ThemesState = initialState, action: ThemesAction): ThemesState {
    switch (action.type) {
        case types.FETCH_THEMES:
            return fetchThemes(state);

        case types.FETCH_THEMES_SUCCESS:
            return fetchThemesSuccess(state, action);

        case types.FETCH_THEMES_ERROR:
            return fetchThemesError(state, action);

        case types.FETCH_THEME:
            return fetchTheme(state);

        case types.FETCH_THEME_SUCCESS:
            return fetchThemeSuccess(state, action);

        case types.FETCH_THEME_ERROR:
            return fetchThemeError(state, action);

        default:
            return state;
    }
}

function fetchThemes(state: ThemesState) {
    return {
        ...state,
        isLoading: true,
        error: false
    };
}

function fetchThemesSuccess(state: ThemesState, action: any) {
    return {
        ...state,
        list: action.payload,
        isLoading: false,
        error: false
    };
}

function fetchThemesError(state: ThemesState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchTheme(state: ThemesState) {
    return {
        ...state,
        isLoading: true,
        error: false
    };
}

function fetchThemeSuccess(state: ThemesState, action: any) {
    return {
        ...state,
        one: action.payload,
        isLoading: false,
        error: false
    };
}

function fetchThemeError(state: ThemesState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

export default reducer;
